import React, { useEffect, useState } from "react";
import { api } from "../utils/api";
import { useApp } from "../context/AppContext";
import { t } from "../utils/i18n";
import { FileText } from "lucide-react";

const STATUS_LABELS: Record<string, string> = { pending_payment: "En attente", active: "Payé", completed: "Payé", cancelled: "Annulé" };

// Historique de paiement — pas de vraie facture Stripe Invoicing (le système utilise des
// Checkout Sessions ponctuelles, pas des Invoices), donc une simple liste date/montant/statut
// à partir des mêmes données que "Mes publicités", présentée différemment (triée par date,
// vocabulaire facturation plutôt que campagne).
export default function AdBilling() {
  const { lang } = useApp();
  const [items, setItems] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/sponsorships/me").then(data => setItems(data?.sponsorships || [])).catch(() => {}).finally(() => setLoading(false));
  }, []);

  if (loading) return <div style={{ textAlign: "center", padding: 40, color: "#999" }}>Chargement…</div>;
  if (items.length === 0) {
    return (
      <div style={{ textAlign: "center", padding: "40px 20px", color: "#999" }}>
        <FileText size={36} strokeWidth={1.5} color="#ccc" style={{ marginBottom: 10 }} />
        <div style={{ fontSize: 14 }}>{t(lang, "ad_tool_no_payments")}</div>
      </div>
    );
  }

  return (
    <div>
      {items.map(s => (
        <div key={s.id} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", backgroundColor: "white", borderRadius: 14, padding: "14px 16px", marginBottom: 10, border: "1px solid #F0F0F0" }}>
          <div>
            <div style={{ fontSize: 14, fontWeight: 700 }}>{s.target_label || "Campagne"}</div>
            <div style={{ fontSize: 12, color: "#999" }}>{new Date(s.created_at).toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" })}</div>
          </div>
          <div style={{ textAlign: "right" }}>
            <div style={{ fontSize: 14, fontWeight: 800 }}>{Number(s.budget_total).toFixed(2)} €</div>
            <div style={{ fontSize: 11, color: "#999" }}>{STATUS_LABELS[s.status] || s.status}</div>
          </div>
        </div>
      ))}
    </div>
  );
}
